import React from 'react';
import { Button } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faRefresh, faCircleExclamation } from '@fortawesome/free-solid-svg-icons';
import {
  HeaderRow,
  HeaderLeft,
  PageTitle,
  PageSubtitle,
  ErrorCard,
  ErrorIconWrap,
  ErrorTitle,
  ErrorText,
  ErrorCardBody,
  ErrorActions,
} from './Styles';
import { PAGE_TITLE, PAGE_SUBTITLE, ERROR_LOADING_TITLE, BUTTON_LABELS } from './constants';
import type { ErrorSectionProps } from './types';

const ErrorSection: React.FC<ErrorSectionProps> = ({
  error,
  onRetry,
  onBack,
  loading,
}) => (
  <>
    <HeaderRow>
      <HeaderLeft>
        <Button
          type="text"
          icon={<FontAwesomeIcon icon={faArrowLeft} />}
          onClick={onBack}
          aria-label="Go back"
        />
        <div>
          <PageTitle>{PAGE_TITLE}</PageTitle>
          <PageSubtitle>{PAGE_SUBTITLE}</PageSubtitle>
        </div>
      </HeaderLeft>
    </HeaderRow>
    <ErrorCard>
      <ErrorCardBody>
        <ErrorIconWrap>
          <FontAwesomeIcon icon={faCircleExclamation} />
        </ErrorIconWrap>
        <ErrorTitle>{ERROR_LOADING_TITLE}</ErrorTitle>
        <ErrorText>{error}</ErrorText>
        <ErrorActions>
          <Button type="primary" icon={<FontAwesomeIcon icon={faRefresh} />} onClick={onRetry} loading={loading}>
            {BUTTON_LABELS.TRY_AGAIN}
          </Button>
          <Button icon={<FontAwesomeIcon icon={faArrowLeft} />} onClick={onBack}>
            {BUTTON_LABELS.GO_BACK}
          </Button>
        </ErrorActions>
      </ErrorCardBody>
    </ErrorCard>
  </>
);

export default React.memo(ErrorSection);
